import { render, staticRenderFns } from "./Workdetail.vue?vue&type=template&id=4ca0f24c&scoped=true"
import script from "./Workdetail.vue?vue&type=script&lang=js"
export * from "./Workdetail.vue?vue&type=script&lang=js"
import style0 from "./Workdetail.vue?vue&type=style&index=0&id=4ca0f24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca0f24c",
  null
  
)

export default component.exports